import { render, staticRenderFns } from "./OrganismCertifications.vue?vue&type=template&id=9465b0e2&"
import script from "./OrganismCertifications.vue?vue&type=script&lang=js&"
export * from "./OrganismCertifications.vue?vue&type=script&lang=js&"
import style0 from "./OrganismCertifications.vue?vue&type=style&index=0&id=9465b0e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesCommonMoleculeCertifications: require('/app/components/molecules/common/MoleculeCertifications.vue').default})
